import { render, staticRenderFns } from "./AggregationIntervalFilter.vue?vue&type=template&id=4529d2dc&scoped=true"
import script from "./AggregationIntervalFilter.vue?vue&type=script&lang=ts"
export * from "./AggregationIntervalFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4529d2dc",
  null
  
)

export default component.exports